import firebase from './firebase.js'
export default firebase
